import { gql } from '@apollo/client';

export const ON_UPDATE_PENDING_ATTENDEE_CONNECTION_COUNT = gql`
  subscription ON_UPDATE_PENDING_ATTENDEE_CONNECTION_COUNT($attendeeId: ID!, $eventId: ID!) {
    attendeeConnectionsStatusChanged(attendeeId: $attendeeId, eventId: $eventId) {
      pendingConnectionsCount
      attendeeId
      eventId
      initiatorAttendeeId
      action
    }
  }
`;
